/*jslint node: true */
/*globals $ */
'use strict';

import globals from './globals';
import $ from 'jquery';

const components = {
  scrollStart: 0,
  scrollDownEnd: 0,
  setCalendar: function (container, year, month, dates, callback) {

    var calendarHolder = container;
    var calendar = $('<div class="calendar" />');
    var header = $('<div class="header" />');
    var weeks = $('<div class="weeks" />');
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var thisYear = year || year === 0 ? year : today.getFullYear();
    var thisMonth = month || month === 0 ? month : today.getMonth();
    var firstDay = new Date(thisYear, thisMonth, 1);
    var prevMonth = firstDay.getMonth() > 0 ? firstDay.getMonth() - 1 : 11;
    var prevYear = prevMonth === 11 ? firstDay.getFullYear() - 1 : firstDay.getFullYear();
    var viewStartDate = firstDay;
    var prevMonthBtn = $('<a href="#" class="prev-month fa" />');
    var nextMonthBtn = $('<a href="#" class="next-month fa" />');
    if (viewStartDate.getDay() !== 1)
      viewStartDate.setDate(firstDay.getDate() - firstDay.getDay() + (firstDay.getDay() === 0 ? -6 : 1));
    header.append('<span class="month">' + globals.months[thisMonth] + '</span> <span class="year">' + thisYear + '</span>');
    header.append(prevMonthBtn);
    header.append(nextMonthBtn);
    calendar.append(header);
    calendar.append(weeks);

    prevMonthBtn.click((e) => {
      e.preventDefault();
      this.setCalendar(calendarHolder, prevYear, prevMonth, dates, callback);
    });

    nextMonthBtn.click((e) => {

      e.preventDefault();

      var newMonth = parseInt(thisMonth) >= 11 ? 0 : parseInt(thisMonth) + 1;
      var newYear = parseInt(thisMonth) >= 11 ? parseInt(thisYear + 1) : thisYear;

      this.setCalendar(calendarHolder, newYear, newMonth, dates, callback);

    });

    for (var w = 0; w <= 5; w++) {

      if ((thisMonth === 0 ? 11 : thisMonth - 1) === viewStartDate.getMonth() || thisMonth === viewStartDate.getMonth()) {

        var week = $('<div class="week" />');

        for (var d = 0; d <= 6; d++) {

          var dayElement = $('<div class="day" />');
          dayElement.attr('data-day', viewStartDate.getDate());
          dayElement.attr('data-month', parseInt(viewStartDate.getMonth() + 1));
          dayElement.attr('data-year', viewStartDate.getFullYear());
          dayElement.html(viewStartDate.getDate());

          if (viewStartDate.getTime() < today.getTime()) dayElement.addClass('disabled');
          //if(viewStartDate.getDate() === (new Date()).getDate() && viewStartDate.getMonth() === (new Date()).getMonth()) dayElement.addClass('today');
          if (!dayElement.hasClass('disabled') &&
            dates[viewStartDate.getFullYear()] &&
            dates[viewStartDate.getFullYear()][viewStartDate.getMonth()] &&
            dates[viewStartDate.getFullYear()][viewStartDate.getMonth()][viewStartDate.getDate()])
            dayElement.addClass('available')
              .attr('data-ms', dates[viewStartDate.getFullYear()][viewStartDate.getMonth()][viewStartDate.getDate()].ms);

          week.append(dayElement);

          viewStartDate.setDate(viewStartDate.getDate() + 1);

        }

        calendar.find('.weeks')
          .append(week);

      }

    }

    calendarHolder.html(calendar);

    if (callback && typeof callback === 'function')
      callback();

  },

  /**
   * Open a given content in a modal dialog, modal is inserted to body element.
   * @param {string} content html markdown
   * @param {function} callback called after element is inserted to DOM
   * @param {jQuery.HTMLElement} preloaded preloaded jQuery.HTMLElement
   * @param {string} customClass custom classes name
   */
  popup: function (content, callback, preloaded, customClass='') {

    var popupOverlay;

    if (preloaded) {

      popupOverlay = preloaded.closest('.popup-holder')
        .prev('.popup-overlay.preload');

      popupOverlay.fadeIn(500)
        .next('.popup-holder')
        .fadeIn(500);

      $('.popup-close')
        .unbind('click')
        .bind('click', function (e) {

          e.preventDefault();
          popupOverlay.fadeOut(500, () => {});

          popupOverlay.next('.popup-holder')
            .fadeOut(500, () => {});

        });

    } else {

      if (/youtube/gi.test(content))
        customClass = ' video';

      var popupMarkUp = '<div class="popup-overlay"></div><div class="popup-holder ' + customClass + '">';
      popupMarkUp += '<div class="popup-table"><div class="popup-cell">';
      popupMarkUp += '<div class="popup-content ' + customClass + '"><a href="#" class="popup-close"></a>' + content + '</div>';
      popupMarkUp += '</div></div>';
      popupMarkUp += '</div>';

      $('body').append(popupMarkUp);

      popupOverlay = $('.popup-overlay:not(.preload)');

      popupOverlay.fadeIn(500)
        .next('.popup-holder')
        .fadeIn(500);

      $('.popup-close')
        .click(function (e) {

          e.preventDefault();
          popupOverlay.fadeOut(500, function () {

            $(this)
              .remove();

          });
          popupOverlay.next('.popup-holder')
            .fadeOut(500, function () {

              $(this)
                .remove();

            });

        });

    }

    $(window).scrollTop(0);

    if (callback && typeof callback === 'function')
      callback();

  },
  stickyBox: function (scrollObj) {

    var el = scrollObj.el;
    var current = Math.ceil($(window).scrollTop());
    var up = current < this.scrollStart;
    this.scrollStart = current;

    var css = {
      width: scrollObj.defaultValues.width ? scrollObj.defaultValues.width : 'auto',
      top: scrollObj.defaultValues.top ? scrollObj.defaultValues.top : 'auto',
      bottom: scrollObj.defaultValues.bottom ? scrollObj.defaultValues.bottom : 'auto',
      left: scrollObj.defaultValues.left ? scrollObj.defaultValues.left : 'auto',
      right: scrollObj.defaultValues.right ? scrollObj.defaultValues.right : 'auto',
    };

    if (up) {

      if (current > scrollObj.settings.start) {

        if (this.scrollDownEnd < current)
          el.css({
            position: 'absolute',
            left: 'auto',
            bottom: 0,
            top: 'auto',
            right: 'auto'
          })
            .addClass('absolute')
            .removeClass('fixed');
        else
          el.css({
            position: 'fixed',
            left: css.left,
            bottom: css.bottom,
            top: css.top,
            right: css.right
          })
            .addClass('fixed')
            .removeClass('absolute');

      } else
        el.css({
          position: 'absolute',
          left: 'auto',
          top: 'auto',
          bottom: 'auto'
        })
          .addClass('absolute')
          .removeClass('fixed');

      if (scrollObj.settings.footer > Math.ceil(el.offset()
        .top + el.outerHeight()))
        scrollObj.settings.overFooter = false;

      scrollObj.settings.end = Math.ceil(el.offset()
        .top);

    } else {

      if (scrollObj.settings.footer > Math.ceil(el.offset()
        .top + el.outerHeight()) && !scrollObj.settings.overFooter) {

        scrollObj.settings.overFooter = false;

        if (current >= scrollObj.settings.start) {

          if (Math.ceil($(window).outerHeight()) <= Math.ceil(el.outerHeight())) {

            if (Math.ceil(current + $(window).outerHeight()) >= scrollObj.settings.bottomPosition)
              el.css({
                position: 'fixed',
                left: css.left,
                top: 'auto',
                bottom: 0,
                right: css.right
              })
                .addClass('fixed')
                .removeClass('absolute');
            else
              el.css({
                position: 'absolute',
                left: css.left,
                top: Math.ceil(scrollObj.settings.end - scrollObj.scrollValues.start) > 0 ? Math.ceil(scrollObj.settings.end - scrollObj.settings.start) : 0,
                bottom: css.bottom
              })
                .addClass('absolute')
                .removeClass('fixed');
          } else
            el.css({
              position: 'fixed',
              left: css.left,
              top: css.top,
              bottom: css.bottom,
              right: css.right
            })
              .addClass('fixed')
              .removeClass('absolute');
        }
      } else {

        el.css({
          position: 'absolute',
          left: 'auto',
          top: 'auto',
          bottom: 0,
          right: 'auto'
        })
          .addClass('absolute')
          .removeClass('fixed');

        scrollObj.settings.overFooter = true;

      }

      this.scrollDownEnd = Math.ceil(el.offset()
        .top);
      scrollObj.settings.bottomPosition = Math.ceil(el.offset()
        .top + el.outerHeight());

    }

  }
}

export default components;
